// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n#Chats-page{\r\n    height: 100%;\r\n    padding: 0;\r\n    overflow: hidden;\r\n}\r\n#Chats-page > .tabs {\r\n    margin: 0 10px 0 0px;\r\n    height: calc(100% - 50px);\r\n}\r\n#Chats-page > .tabs .tab-content {\r\n    background: #fff;\r\n}\r\n#Chats-page > .tabs div[id$=\"-tab\"]{\r\n    height: 100%;\r\n}\r\n#Chats-page > .tabs iframe {\r\n    border: none;\r\n    height: 100%;\r\n}\r\n#Chats-page > .tabs iframe body footer{\r\n    margin-right: 60px;\r\n}", ""]);
// Exports
module.exports = exports;
